import styled, { css } from 'styled-components';
import { Inputs } from '@taxdown/piccolo-web';

export const StyledEmailInput = styled(Inputs.Text)`
  span {
    font-size: ${({ theme: { typography } }) => typography.fds_text_regular_XS['font-size']};
  }
  ${({ hasWarning, theme: { colors } }) =>
    hasWarning &&
    css`
      input {
        border: 1px solid ${colors.warning_500};
      }
      span {
        color: ${colors.warning_500};
      }
    `}
`;
